<template>
    <div >
        <div class="bb-1 p-3">
            <slot name="title"></slot>
        </div>
        <div class="p-3">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data(){
            return {
            }
        },
    }
</script>

<style scoped>

</style>